module.exports = __webpack_public_path__ + "static/media/arrow_blue svg.309772ce.svg";